import LikesUserPage from './components/LikesUserPage';
import PostLikedNotification from './components/PostLikedNotification';
import PostLikesModal from './components/PostLikesModal';
import PostLikesModalState from './states/PostLikesModalState';

export default {
  'likes/components/LikesUserPage': LikesUserPage,
  'likes/components/PostLikedNotification': PostLikedNotification,
  'likes/components/PostLikesModal': PostLikesModal,
  'likes/states/PostLikesModalState': PostLikesModalState,
};
